import { Component, EventEmitter, Input, OnInit, Output } from "@angular/core";
import moment from "moment";
import { FocuslinkService } from "src/app/core/services/focuslink.service";
import { ManagerLogCommentItem } from "src/app/shared/models/ManagerLogComment.item";
import { ManagerLogPostItem } from "src/app/shared/models/ManagerLogPost.item";
import { User } from "src/app/shared/models/user.model";

@Component({
	selector: "app-log-comment-create",
	templateUrl: "./log-comment-create.component.html",
	styleUrls: ["../../../../../commandcenter.scss"],
})
export class LogCommentCreateComponent implements OnInit {
	@Input() managerLogPostSelected: ManagerLogPostItem;
	@Input() currentUser: User;
	@Output() clearEmitter = new EventEmitter<boolean>();
	@Output() commentEmitter = new EventEmitter<ManagerLogCommentItem>();

	comment: ManagerLogCommentItem;
	moment: any = moment;

	constructor(private focuslink: FocuslinkService) {}

	ngOnInit(): void {
		this.initNewComment();
	}

	initNewComment() {
		if (!this.managerLogPostSelected.managerLogComments || this.managerLogPostSelected.managerLogComments.length === 0) {
			this.managerLogPostSelected.managerLogComments = [];
		}
		this.managerLogPostSelected.managerLogComments.push(
			new ManagerLogCommentItem({
				pk: this.managerLogPostSelected.pk,
				sk: this.managerLogPostSelected.sk + `_COMMENT_${moment().valueOf()}`,
				authorUserKey: this.currentUser.key,
				created: moment().format(),
				authorUser: this.currentUser,
			})
		);
		this.comment = this.managerLogPostSelected.managerLogComments[this.managerLogPostSelected.managerLogComments.length - 1];
	}

	save() {
		this.comment.saved = true;
		this.focuslink.managerLogCommentPost(+this.managerLogPostSelected.pk.replace("LOG_", ""), this.managerLogPostSelected.sk, this.comment);
		this.commentEmitter.emit(this.comment);
		this.initNewComment();
	}
}
